module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"Setting off: Rio de Janeiro via Lisbon","path":"/rio-via-lison"}}}]}},"pathContext":{"tag":"flights"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-flights.json
// module id = 417
// module chunks = 159947537236901